import React from 'react';

const SkillBox = ({ name, src, size = 80 }) => {
    return (
        <div className="flex flex-col items-center">
            <section
                className="flex rounded-lg bg-white shadow-sm hover:shadow-md items-center justify-center transition-all duration-300 hover:bg-slate-50"
                style={{
                    width: `${size}px`,
                    height: `${size}px`,
                    maxWidth: '80px',
                    maxHeight: '80px',
                    minWidth: '60px',
                    minHeight: '60px',
                }}
            >
                <img
                    className="w-full h-full object-contain p-2 transition-transform duration-300"
                    src={src}
                    alt={name}
                />
            </section>
            <p className="text-slate-600 mt-1.5 text-xs sm:text-sm font-medium text-center">{name}</p>
        </div>
    );
};

export default SkillBox;